module.exports = __webpack_public_path__ + "static/media/mobileApps.3b2a4e39.png";